// // helper to show ISO dates in <input type="datetime-local">
function isoToInput(iso) {
  if (!iso) return '';
  // Convert Date objects to ISO string first
  if (iso instanceof Date) {
    iso = iso.toISOString();
  }
  // Ensure it's a string before slicing
  if (typeof iso !== 'string') {
    iso = String(iso);
  }
  // "2025-11-12T13:40:42.642Z" -> "2025-11-12T13:40"
  return iso.slice(0, 16);
}

// // helper to convert back to ISO (or null if empty)
function inputToIso(value) {
  if (!value) return null;
  return new Date(value).toISOString();
}

function cleanAndCapitalize(input) {
  if (input === 'co2_ratio_min') return 'Ventilation';
  const substringsToRemove = ['mass', 'min', 'max'];

  let cleanedString = input;

  cleanedString = cleanedString.replace(/_/g, ' ');

  substringsToRemove.forEach(substring => {
    const regex = new RegExp(substring, 'gi'); // Case-insensitive match
    cleanedString = cleanedString.replace(regex, '');
  });

  cleanedString = cleanedString.trim();
  return cleanedString.charAt(0).toUpperCase() + cleanedString.slice(1);
}

function splitByInsightId(objects) {
  const result = [];

  objects.forEach(obj => {
    // Group data by insightId
    const groupedData = obj.data.reduce((acc, entry) => {
      const { insightId } = entry;
      if (!acc[insightId]) {
        acc[insightId] = [];
      }
      acc[insightId].push(entry);
      return acc;
    }, {});

    // Create new objects for each insightId
    Object.keys(groupedData).forEach(insightId => {
      result.push({
        location: obj.location,
        sensor_name: obj.sensor_name,
        data: groupedData[insightId],
      });
    });
  });

  return result;
}

function tvocToMass(tvoc) {
  const res = (Math.log(501 - tvoc) - 6.24) * -996.94;
  return Math.round(res);
}

function getDateString(daysToSubstruct) {
  const now = new Date();

  // Set the date to yesterday
  now.setDate(now.getDate() - daysToSubstruct);

  // Extract day, month, and year
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = now.getFullYear();
  return `${day}.${month}.${year}`;
}

function getTimeRangeOneHour(dateTimeStr) {
  const [datePart, timePart] = dateTimeStr.split(' ');
  const [day, month] = datePart.split('.').map(Number);
  const [hour, minute] = timePart.split(':').map(Number);
  const currentYear = new Date().getFullYear();
  const inputDate = new Date(currentYear, month - 1, day, hour, minute);
  const startDate = new Date(inputDate);
  startDate.setMinutes(startDate.getMinutes() - 5);

  const pad = num => num.toString().padStart(2, '0');

  return `${datePart} ${pad(startDate.getHours())}:${pad(startDate.getMinutes())} - ${pad(inputDate.getHours())}:${pad(inputDate.getMinutes())}`;
}

function getTimeRangeOneDay(dateTimeStr) {
  const [datePart, timePart] = dateTimeStr.split(' ');
  const [day, month] = datePart.split('.').map(Number);
  const [hour, minute] = timePart.split(':').map(Number);
  const currentYear = new Date().getFullYear();
  const inputDate = new Date(currentYear, month - 1, day, hour, minute);
  const startDate = new Date(inputDate);
  startDate.setMinutes(startDate.getMinutes() - 30);

  const pad = num => num.toString().padStart(2, '0');

  return `${datePart} ${pad(startDate.getHours())}:${pad(startDate.getMinutes())} - ${pad(inputDate.getHours())}:${pad(inputDate.getMinutes())}`;
}

function getTimeRangeOneWeek(dateTimeStr) {
  const [datePart, timePart] = dateTimeStr.split(' ');
  const [day, month] = datePart.split('.').map(Number);
  const [hour, minute] = timePart.split(':').map(Number);
  const currentYear = new Date().getFullYear();
  const inputDate = new Date(currentYear, month - 1, day, hour, minute);
  const startDate = new Date(inputDate);
  startDate.setHours(startDate.getHours() - 1);

  const pad = num => num.toString().padStart(2, '0');

  return `${datePart} ${pad(startDate.getHours())}:${pad(startDate.getMinutes())} - ${pad(inputDate.getHours())}:${pad(inputDate.getMinutes())}`;
}

function getTodayDateFormatted() {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = today.getFullYear();
  return `${day}.${month}.${year}`;
}

function getSelectedTimeRangeForNavDisplay(start, end) {
  const today = getTodayDateFormatted(); // expected format "dd.mm.yyyy"

  // Guard: if inputs are missing
  if (!start || !end) return '';

  // Split into parts
  const [sDay, sMonth, sYear] = start.split('.');
  const [eDay, eMonth, eYear] = end.split('.');

  // Case 1: same day
  if (start === end) {
    if (start === today) return ''; // hide if today
    return start;
  }

  // Case 2: same month & year → show "dd - dd.mm.yyyy"
  if (sMonth === eMonth && sYear === eYear) {
    return `${sDay}-${eDay}.${eMonth}.${eYear}`;
  }

  // Case 3: different month/year
  return `${start} - ${end}`;
}

function getDelayUntilNextFiveMinute59() {
  const now = new Date();

  // Minutes into the current hour
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();
  const ms = now.getMilliseconds();

  // How many minutes until the next multiple of 5
  const minutesToNext = 5 - (minutes % 5);

  // Build the next target timestamp
  const target = new Date(now);
  target.setSeconds(1, 0); // move to xx:??:59.000

  // If we’re already past :59 in this 5-min block, move forward
  if (seconds > 1 || (seconds === 1 && ms > 0)) {
    target.setMinutes(now.getMinutes() + minutesToNext, 1, 0);
  } else {
    target.setMinutes(now.getMinutes() + minutesToNext - 1, 1, 0);
  }

  return target.getTime() - now.getTime();
}

function formatDateRange(date1, date2) {
  if (!date1 || !date2) return '';

  // Ensure date1 is before date2 for consistent output
  if (date2 < date1) [date1, date2] = [date2, date1];

  const sameDay = date1.hasSame(date2, 'day');
  const sameMonthYear = date1.hasSame(date2, 'month') && date1.hasSame(date2, 'year');

  if (sameDay) {
    return date1.toFormat('dd.MM.yyyy');
  } else if (sameMonthYear) {
    return `${date1.toFormat('dd')}-${date2.toFormat('dd.MM.yyyy')}`;
  } else {
    return `${date1.toFormat('dd.MM.yyyy')} - ${date2.toFormat('dd.MM.yyyy')}`;
  }
}

function calculatePercentage(count, totalHours) {
  if (!totalHours || totalHours <= 0) return 0;

  const totalIntervals = totalHours * 12; // 12 intervals of 5 min per hour

  // Round to 1 decimal place
  return Math.round((count / totalIntervals) * 100 * 10) / 10;
}

function parseScheduleTimeToSeconds(timeValue) {
  if (!timeValue || typeof timeValue !== 'string') return null;
  const trimmed = timeValue.trim();
  if (!trimmed) return null;

  const match = trimmed.match(/^([01]\d|2[0-3]):([0-5]\d)(?::([0-5]\d))?$/);
  if (!match) return null;

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  const seconds = Number(match[3] || 0);

  return hours * 3600 + minutes * 60 + seconds;
}

function parseDateDdMmYyyy(value) {
  if (!value || typeof value !== 'string') return null;
  const parts = value.split('.');
  if (parts.length !== 3) return null;

  const day = Number(parts[0]);
  const month = Number(parts[1]);
  const year = Number(parts[2]);
  if (!Number.isInteger(day) || !Number.isInteger(month) || !Number.isInteger(year)) return null;

  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null;
  }
  return date;
}

function getDailyScheduleIntervals(startSeconds, endSeconds) {
  if (startSeconds === endSeconds) {
    return [[0, 24 * 3600]];
  }
  if (endSeconds > startSeconds) {
    return [[startSeconds, endSeconds]];
  }
  // Overnight schedule for same weekday (e.g., 22:00 -> 06:00)
  return [
    [0, endSeconds],
    [startSeconds, 24 * 3600],
  ];
}

// Sum all daily ON ranges (in hours) from CAV schedule objects keyed by day-of-week (0..6).
function calculateTotalOnHours(cav_start_time = {}, cav_end_time = {}) {
  const dayKeys = new Set([
    ...Object.keys(cav_start_time || {}),
    ...Object.keys(cav_end_time || {}),
  ]);

  let totalSeconds = 0;

  dayKeys.forEach(dayKey => {
    const startSeconds = parseScheduleTimeToSeconds(cav_start_time?.[dayKey]);
    const endSeconds = parseScheduleTimeToSeconds(cav_end_time?.[dayKey]);

    // Skip days with missing/invalid schedule values.
    if (startSeconds === null || endSeconds === null) return;

    // Same start/end means full-day ON.
    if (startSeconds === endSeconds) {
      totalSeconds += 24 * 3600;
      return;
    }

    // Handle normal and overnight ranges.
    if (endSeconds > startSeconds) {
      totalSeconds += endSeconds - startSeconds;
    } else {
      totalSeconds += 24 * 3600 - startSeconds + endSeconds;
    }
  });

  return Math.round((totalSeconds / 3600) * 100) / 100;
}

// Sum ON-window hours for the selected date range.
// For today's date, only counts active hours that have already elapsed (up to current time).
function calculateOnWindowHoursForRange(
  cav_start_time = {},
  cav_end_time = {},
  timeRange = {},
  nowDate = new Date(),
) {
  const startDate = parseDateDdMmYyyy(timeRange?.startDate);
  const endDate = parseDateDdMmYyyy(timeRange?.endDate);

  if (!startDate || !endDate) {
    return calculateTotalOnHours(cav_start_time, cav_end_time);
  }

  const start = startDate <= endDate ? startDate : endDate;
  const end = endDate >= startDate ? endDate : startDate;

  const today = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate());
  const nowSeconds = nowDate.getHours() * 3600 + nowDate.getMinutes() * 60 + nowDate.getSeconds();

  let totalSeconds = 0;

  for (const d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    const dayKey = String(d.getDay());
    const startSeconds = parseScheduleTimeToSeconds(cav_start_time?.[dayKey]);
    const endSeconds = parseScheduleTimeToSeconds(cav_end_time?.[dayKey]);

    // Empty/invalid times mean 0 active hours for that day.
    if (startSeconds === null || endSeconds === null) continue;

    const currentDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    let dayCapSeconds = 24 * 3600;

    if (currentDay.getTime() > today.getTime()) {
      dayCapSeconds = 0;
    } else if (currentDay.getTime() === today.getTime()) {
      dayCapSeconds = nowSeconds;
    }

    if (dayCapSeconds <= 0) continue;

    const intervals = getDailyScheduleIntervals(startSeconds, endSeconds);
    for (const [intervalStart, intervalEnd] of intervals) {
      const effectiveEnd = Math.min(intervalEnd, dayCapSeconds);
      if (effectiveEnd > intervalStart) {
        totalSeconds += effectiveEnd - intervalStart;
      }
    }
  }

  return Math.round((totalSeconds / 3600) * 100) / 100;
}

// Sum full CAV active hours for every day in the selected date range.
// Unlike calculateOnWindowHoursForRange, today's day is counted as full scheduled hours.
function calculateTotalCavActiveHoursForRange(
  cav_start_time = {},
  cav_end_time = {},
  timeRange = {},
) {
  const startDate = parseDateDdMmYyyy(timeRange?.startDate);
  const endDate = parseDateDdMmYyyy(timeRange?.endDate);

  if (!startDate || !endDate) {
    return calculateTotalOnHours(cav_start_time, cav_end_time);
  }

  const start = startDate <= endDate ? startDate : endDate;
  const end = endDate >= startDate ? endDate : startDate;

  let totalSeconds = 0;

  for (const d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    const dayKey = String(d.getDay());
    const startSeconds = parseScheduleTimeToSeconds(cav_start_time?.[dayKey]);
    const endSeconds = parseScheduleTimeToSeconds(cav_end_time?.[dayKey]);

    // Empty/invalid times mean 0 active hours for that day.
    if (startSeconds === null || endSeconds === null) continue;

    const intervals = getDailyScheduleIntervals(startSeconds, endSeconds);
    for (const [intervalStart, intervalEnd] of intervals) {
      if (intervalEnd > intervalStart) {
        totalSeconds += intervalEnd - intervalStart;
      }
    }
  }

  return Math.round((totalSeconds / 3600) * 100) / 100;
}

const CONTROLLER_ENERGY_PROFILES_10S = {
  FCU: {
    12.0: {
      cooling: { chiller: 0.001236, gas: 0.001528 },
      heating: { 'hot water': 0.000715, 'heating coils': 0.001861 },
    },
    25.0: {
      cooling: { chiller: 0.002503, gas: 0.003111 },
      heating: { 'hot water': 0.001418, 'heating coils': 0.003806 },
    },
    50.0: {
      cooling: { chiller: 0.005035, gas: 0.00625 },
      heating: { 'hot water': 0.002865, 'heating coils': 0.007639 },
    },
    75.0: {
      cooling: { chiller: 0.007483, gas: 0.009306 },
      heating: { 'hot water': 0.004227, 'heating coils': 0.011389 },
    },
    100.0: {
      cooling: { chiller: 0.009931, gas: 0.012361 },
      heating: { 'hot water': 0.00559, 'heating coils': 0.015139 },
    },
    150.0: {
      cooling: { chiller: 0.014826, gas: 0.018472 },
      heating: { 'hot water': 0.008316, 'heating coils': 0.022639 },
    },
    200.0: {
      cooling: { chiller: 0.019722, gas: 0.024583 },
      heating: { 'hot water': 0.011042, 'heating coils': 0.030139 },
    },
    250.0: {
      cooling: { chiller: 0.024757, gas: 0.030833 },
      heating: { 'hot water': 0.013906, 'heating coils': 0.037778 },
    },
  },
  AHU: {
    100.0: {
      cooling: { chiller: 0.011458, gas: 0.013889 },
      heating: { 'hot water': 0.007118, 'heating coils': 0.016667 },
    },
    150.0: {
      cooling: { chiller: 0.017188, gas: 0.020833 },
      heating: { 'hot water': 0.010677, 'heating coils': 0.025 },
    },
    250.0: {
      cooling: { chiller: 0.028646, gas: 0.034722 },
      heating: { 'hot water': 0.017795, 'heating coils': 0.041667 },
    },
    300.0: {
      cooling: { chiller: 0.034375, gas: 0.041667 },
      heating: { 'hot water': 0.021354, 'heating coils': 0.05 },
    },
    350.0: {
      cooling: { chiller: 0.040104, gas: 0.048611 },
      heating: { 'hot water': 0.024913, 'heating coils': 0.058333 },
    },
    400.0: {
      cooling: { chiller: 0.045833, gas: 0.055556 },
      heating: { 'hot water': 0.028472, 'heating coils': 0.066667 },
    },
    450.0: {
      cooling: { chiller: 0.051563, gas: 0.0625 },
      heating: { 'hot water': 0.032031, 'heating coils': 0.075 },
    },
    500.0: {
      cooling: { chiller: 0.057292, gas: 0.069444 },
      heating: { 'hot water': 0.03559, 'heating coils': 0.083333 },
    },
  },
};

const CONTROLLER_UNIT_AIRFLOW_MAP = {
  FCU: {
    cfm_to_area: {
      350.0: 12.0,
      600.0: 25.0,
      1000.0: 50.0,
      1500.0: 75.0,
      2000.0: 100.0,
      3000.0: 150.0,
      4000.0: 200.0,
      5000.0: 250.0,
    },
    fan_kw_by_area: {
      12.0: 0.07,
      25.0: 0.12,
      50.0: 0.25,
      75.0: 0.35,
      100.0: 0.45,
      150.0: 0.65,
      200.0: 0.85,
      250.0: 1.1,
    },
  },
  AHU: {
    cfm_to_area: {},
    fan_kw_by_area: {
      100.0: 1.0,
      150.0: 1.5,
      250.0: 2.5,
      300.0: 3.0,
      350.0: 3.5,
      400.0: 4.0,
      450.0: 4.5,
      500.0: 5.0,
    },
  },
};

function toFiniteNumberOrNull(value) {
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}

function normalizeEnergyType(value) {
  const normalizedValue = String(value || '')
    .trim()
    .toLowerCase();
  const energyTypeAliases = {
    'chiller (water)': 'chiller',
    'dx/vrf': 'gas',
    'dx / vrf': 'gas',
    'electric spiral': 'heating coils',
    'heat pump': 'hot water',
    'heating coil': 'heating coils',
  };
  return energyTypeAliases[normalizedValue] ?? normalizedValue;
}

function getNearestProfileArea(unitType, areaM2) {
  const profile = CONTROLLER_ENERGY_PROFILES_10S[unitType];
  if (!profile) return null;

  const areas = Object.keys(profile).map(Number).filter(Number.isFinite);
  if (areas.length === 0) return null;
  if (!Number.isFinite(areaM2)) return Math.min(...areas);

  return areas.reduce(
    (nearest, current) =>
      Math.abs(current - areaM2) < Math.abs(nearest - areaM2) ? current : nearest,
    areas[0],
  );
}

function getEffectiveAreaForProfile(unitType, areaM2, areaCfm, areaFanKw) {
  if (Number.isFinite(areaM2)) return areaM2;

  const unitMap = CONTROLLER_UNIT_AIRFLOW_MAP[unitType] || {};
  const cfmToArea = unitMap.cfm_to_area || {};
  if (Number.isFinite(areaCfm) && Object.keys(cfmToArea).length > 0) {
    const nearestCfm = Object.keys(cfmToArea)
      .map(Number)
      .reduce(
        (nearest, current) => {
          return Math.abs(current - areaCfm) < Math.abs(nearest - areaCfm) ? current : nearest;
        },
        Number(Object.keys(cfmToArea)[0]),
      );
    return cfmToArea[nearestCfm];
  }

  const fanKwByArea = unitMap.fan_kw_by_area || {};
  if (Number.isFinite(areaFanKw) && Object.keys(fanKwByArea).length > 0) {
    const areas = Object.keys(fanKwByArea).map(Number).filter(Number.isFinite);
    const nearestArea = areas.reduce((nearest, current) =>
      Math.abs(fanKwByArea[current] - areaFanKw) < Math.abs(fanKwByArea[nearest] - areaFanKw)
        ? current
        : nearest,
    );
    return nearestArea;
  }

  return null;
}

function resolveControllerProfileKwhPer10s(controllerParams = {}) {
  const unitType = String(controllerParams.unit_type || '')
    .trim()
    .toUpperCase();
  if (!CONTROLLER_ENERGY_PROFILES_10S[unitType]) return null;

  const areaM2 = toFiniteNumberOrNull(controllerParams.area_m2);
  const areaCfm = toFiniteNumberOrNull(controllerParams.area_cfm);
  const areaFanKw = toFiniteNumberOrNull(controllerParams.area_fan_kw);
  const modeValue = String(controllerParams.mode ?? controllerParams.mode_value ?? 'cool')
    .trim()
    .toLowerCase();

  const effectiveArea = getEffectiveAreaForProfile(unitType, areaM2, areaCfm, areaFanKw);
  const profileArea = getNearestProfileArea(unitType, effectiveArea);
  if (!Number.isFinite(profileArea)) return null;

  const profile = CONTROLLER_ENERGY_PROFILES_10S[unitType]?.[profileArea];
  if (!profile) return null;

  const isHeatingMode = modeValue === 'heat';
  const energyBucket = isHeatingMode ? 'heating' : 'cooling';
  const requestedEnergyType = normalizeEnergyType(
    isHeatingMode ? controllerParams.heating_type : controllerParams.cooling_type,
  );
  let profileKwhPer10s = profile?.[energyBucket]?.[requestedEnergyType];

  if (!Number.isFinite(profileKwhPer10s)) {
    const fallbackType = isHeatingMode ? 'hot water' : 'chiller';
    profileKwhPer10s = profile?.[energyBucket]?.[fallbackType];
  }

  return Number.isFinite(profileKwhPer10s) ? profileKwhPer10s : null;
}

/**
 * Calculate controller baseline (kWh waste potential) for selected date range.
 * - Uses selected building CAV schedule to compute active hours in range.
 * - Uses per-10-second energy profile to scale by active 10-second windows.
 * - Mirrors kwh_calculations.py table-based baseline logic.
 */
function calculateKwhWastePotentialBaselineForSelectedRange(
  cavActiveHours = {},
  selectedTimeRange = {},
  controllerParams = {},
) {
  const cavStartByDay = cavActiveHours?.cav_start_time || cavActiveHours?.cavStartTime || {};
  const cavEndByDay = cavActiveHours?.cav_end_time || cavActiveHours?.cavEndTime || {};

  const totalCavActiveHours = calculateTotalCavActiveHoursForRange(
    cavStartByDay,
    cavEndByDay,
    selectedTimeRange,
  );

  const profileKwhPer10s = resolveControllerProfileKwhPer10s(controllerParams);
  if (!Number.isFinite(profileKwhPer10s) || !Number.isFinite(totalCavActiveHours)) return null;

  const total10sWindows = totalCavActiveHours * 60 * 6;
  const baselineKwh = profileKwhPer10s * total10sWindows;

  return Number(baselineKwh.toFixed(2));
}

module.exports = {
  formatDateRange,
  cleanAndCapitalize,
  splitByInsightId,
  tvocToMass,
  getDateString,
  getTimeRangeOneHour,
  getTimeRangeOneDay,
  getTimeRangeOneWeek,
  getTodayDateFormatted,
  formatDateRange,
  getSelectedTimeRangeForNavDisplay,
  getDelayUntilNextFiveMinute59,
  calculatePercentage,
  calculateTotalOnHours,
  calculateOnWindowHoursForRange,
  calculateTotalCavActiveHoursForRange,
  calculateKwhWastePotentialBaselineForSelectedRange,
  isoToInput,
  inputToIso,
};
